import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-grey-search.svg'


const _withScopeId = n => (_pushScopeId("data-v-12143312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "search"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: "search",
      type: "text",
      placeholder: "Search",
      autocomplete: "off",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputString) = $event)),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)), ["esc"]))
      ]
    }, null, 544), [
      [_vModelText, _ctx.inputString]
    ]),
    _hoisted_2
  ]))
}